import type { ReactNode } from "react";
import lazySuspense from "ui/hooks/lazySuspense";
import type { DonutChartProps } from "./DonutChart";
import styles from "./LocationSummaryView.module.scss";

const DonutChart = lazySuspense(() => import("./DonutChart"));

export default function StatCard({
  title,
  stat,
  caption,
  donut,
}: {
  title: string;
  stat: string;
  caption?: string;
  donut?: DonutChartProps;
}): ReactNode {
  return (
    <article className={donut ? `${styles.statCard} ${styles.statCardWithDonut}` : styles.statCard}>
      <div className={styles.statCardText}>
        <h3 className={styles.statTitle}>{title}</h3>
        <div className={styles.stat}>{stat}</div>
        {caption && <p className={styles.caption}>{caption}</p>}
      </div>
      {donut && <DonutChart {...donut} />}
    </article>
  );
}
